import { createAction, props } from '@ngrx/store';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { DireccionGeograficaIDE } from './direcciones-geografica-ide.model';

// LOAD REQUEST
export const entityDireccionesGeograficaIDELoadRequest = createAction(
  '[ENTITYDIRECCIONESGEOGRAFICASIDE] Load Request',
  props<{ q: string, mapa: string }>()
);

export const entityDireccionesGeograficaIDELoadFailure = createAction(
  '[ENTITYDIRECCIONESGEOGRAFICASIDE] Load Failure',
  props<{ error: Error }>()
);

export const entityDireccionesGeograficaIDELoadSuccess = createAction(
  '[ENTITYDIRECCIONESGEOGRAFICASIDE] Load Success',
  props<{ items: DireccionGeograficaIDE[], mapa: string }>()
);

